import { Box, Input } from "@chakra-ui/react";

export default function FileUploader({ onChange }) {
  return (
    <Box position="absolute" top="0" left="0">
      <Box
        as="label"
        htmlFor="file-upload"
        display="inline-block"
        height="64px"
        width="64px"
        opacity="0"
        _hover={{ cursor: "pointer" }}
      />
      <Input
        onChange={onChange}
        id="file-upload"
        type="file"
        accept="image/png, image/jpeg"
        display="none"
      />
    </Box>
  );
}
